"use client";

import type { SvgName } from "../../../svg";
import { Button } from "../../ui/button";
import { providers } from "./share.providers";
import { useShare } from "./use-share";

type ShareProps = {
  wrap?: boolean;
};

function Share(props: ShareProps) {
  const { styles, onSharePost } = useShare();
  const { wrap = false } = props;

  return (
    <ul className={styles.base({ wrap })}>
      {providers.map(({ title, url }) => {
        const provider = title.toLowerCase() as SvgName;

        return (
          <li className={styles.item()} key={title}>
            <Button
              appearance="solid"
              aria-label={title}
              color="gray"
              onClick={() => {
                onSharePost(url, provider);
              }}
              rounded
              size="sm"
              startIcon={provider}
              type="button"
            />
          </li>
        );
      })}
    </ul>
  );
}

export default Share;
